export const iconFontAwesomeHandsHandshakeSlash = (
	<i className="fa-solid fa-handshake-slash"></i>
);
